'use client'

import { useEffect } from 'react'
import { ApiUnavailablePage } from '@/General/ApiUnavailablePage'
import { reportClientError } from '@/lib/logging/clientErrorReporter'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
    reportClientError(error, 'app_error_boundary')
  }, [error])

  return <ApiUnavailablePage error={error} reset={reset} />
}
